// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/safety_requirements.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/model/booking/activity/safety_requirements.proto.
 */
export const file_proto_model_booking_activity_safety_requirements = /*@__PURE__*/
  fileDesc("CjZwcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L3NhZmV0eV9yZXF1aXJlbWVudHMucHJvdG8SBmNhcm1lbiLiCAoSU2FmZXR5UmVxdWlyZW1lbnRzEkoKE3dhaXZlcl9yZXF1aXJlbWVudHMYASABKAsyLS5jYXJtZW4uU2FmZXR5UmVxdWlyZW1lbnRzLldhaXZlclJlcXVpcmVtZW50cxJGChFtZWRpY2FsX2NsZWFyYW5jZRgCIAEoCzIrLmNhcm1lbi5TYWZldHlSZXF1aXJlbWVudHMuTWVkaWNhbENsZWFyYW5jZRJEChFyZXF1aXJlZF90cmFpbmluZxgDIAMoCzIpLmNhcm1lbi5TYWZldHlSZXF1aXJlbWVudHMuU2FmZXR5VHJhaW5pbmcSUAoWaW5zdXJhbmNlX3JlcXVpcmVtZW50cxgEIAEoCzIwLmNhcm1lbi5TYWZldHlSZXF1aXJlbWVudHMuSW5zdXJhbmNlUmVxdWlyZW1lbnRzEigKIGxvY2FsX2VtZXJnZW5jeV9jb250YWN0X3JlcXVpcmVkGAUgASgIGscBChJXYWl2ZXJSZXF1aXJlbWVudHMSHwoXbGlhYmlsaXR5X3dhaXZlcl9zaWduZWQYASABKAgSNgoSd2FpdmVyX3NpZ25lZF9kYXRlGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIaChJ3YWl2ZXJfZG9jdW1lbnRfaWQYAyABKAkSHAoUcGhvdG9fcmVsZWFzZV9zaWduZWQYBCABKAgSHgoWbWVkaWNhbF9yZWxlYXNlX3NpZ25lZBgFIAEoCBrKAQoQTWVkaWNhbENsZWFyYW5jZRIiChptZWRpY2FsX2NsZWFyYW5jZV9yZXF1aXJlZBgBIAEoCBIyCg5jbGVhcmFuY2VfZGF0ZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGgoSY2xlYXJpbmdfcGh5c2ljaWFuGAMgASgJEhwKFG1lZGljYWxfcmVzdHJpY3Rpb25zGAQgAygJEiQKHHJlcXVpcmVkX21lZGljYXRpb25zX29uX2hhbmQYBSADKAkarwEKDlNhZmV0eVRyYWluaW5nEhUKDXRyYWluaW5nX3R5cGUYASABKAkSMwoPY29tcGxldGlvbl9kYXRlGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIcChRjZXJ0aWZpY2F0aW9uX251bWJlchgDIAEoCRIzCg9leHBpcmF0aW9uX2RhdGUYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wGqwBChVJbnN1cmFuY2VSZXF1aXJlbWVudHMSIwobYWN0aXZpdHlfaW5zdXJhbmNlX3JlcXVpcmVkGAEgASgIEiMKG3BlcnNvbmFsX2luc3VyYW5jZV92ZXJpZmllZBgCIAEoCBIaChJpbnN1cmFuY2VfcHJvdmlkZXIYAyABKAkSFQoNcG9saWN5X251bWJlchgEIAEoCRIWCg5jb3ZlcmFnZV90eXBlcxgFIAMoCUIwWi5naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9ib29raW5nYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Describes the message carmen.SafetyRequirements.
 * Use `create(SafetyRequirementsSchema)` to create a new message.
 */
export const SafetyRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_safety_requirements, 0);

/**
 * Describes the message carmen.SafetyRequirements.WaiverRequirements.
 * Use `create(SafetyRequirements_WaiverRequirementsSchema)` to create a new message.
 */
export const SafetyRequirements_WaiverRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_safety_requirements, 0, 0);

/**
 * Describes the message carmen.SafetyRequirements.MedicalClearance.
 * Use `create(SafetyRequirements_MedicalClearanceSchema)` to create a new message.
 */
export const SafetyRequirements_MedicalClearanceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_safety_requirements, 0, 1);

/**
 * Describes the message carmen.SafetyRequirements.SafetyTraining.
 * Use `create(SafetyRequirements_SafetyTrainingSchema)` to create a new message.
 */
export const SafetyRequirements_SafetyTrainingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_safety_requirements, 0, 2);

/**
 * Describes the message carmen.SafetyRequirements.InsuranceRequirements.
 * Use `create(SafetyRequirements_InsuranceRequirementsSchema)` to create a new message.
 */
export const SafetyRequirements_InsuranceRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_safety_requirements, 0, 3);

